function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16,13c-1.4,0-2.9,0.6-4,1.7c-2.2,2.3-2.2,6,0,8.3L34.8,51c0.2,0.2,0.4,0.4,0.6,0.6c0,0,0,0,0,0.1v19.6c0,0.5,0,1,0.1,1.5 c-0.1,0.4-0.2,14.9-0.2,15.3h11.4h3.9h11.5c0-0.4-0.2-14.9-0.2-15.3c0.1-0.5,0.1-1,0.1-1.5V51.6c0,0,0,0,0-0.1 c0.2-0.2,0.4-0.4,0.6-0.6l22.2-29c2.2-2.3,2.2-6,0-8.3c-2.2-2.3-5.8-2.3-8,0l-22.2,29c-0.1,0.1-0.3,0.3-0.4,0.4c-0.2,0-0.3,0-0.5,0 H43.7c-0.2,0-0.3,0-0.5,0c-0.1-0.1-0.2-0.3-0.4-0.4L20,14.7C18.9,13.6,17.5,13,16,13z M48.4,22.5c-5.1,0-9.1,4.1-9.1,9.1 s4.1,9.1,9.1,9.1c5.1,0,9.1-4.1,9.1-9.1S53.5,22.5,48.4,22.5z"
});

function SvgWeeklyChallenge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeeklyChallenge);
export default __webpack_public_path__ + "static/media/WeeklyChallenge.e482ce6b.svg";
export { ForwardRef as ReactComponent };